import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './interceptor/http.interceptor';
import { AppInitService } from './core/services/app-init.service';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { routes } from './app.routes';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [AppInitService],
      multi: true
    },
    provideLottieOptions({
      player: () => player,
    }),
    // Translation providers
    importProvidersFrom(
      TranslateModule.forRoot({
        // defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, '/assets/i18n/', '.json'),
          deps: [HttpClient]
        }
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, HttpClient],
      multi: true
    }
  ]
};

export function configServiceFactory(appInitService: AppInitService): () => Promise<void> {
  return () => appInitService.Init();
}

// Translation initializer
export function appInitializerFactory(translate: TranslateService, http: HttpClient) {
  return async () => {
    // Set default language
    translate.setDefaultLang('en');
    
    // Try to get language from localStorage
    const savedLang = localStorage.getItem('userLanguage');
    
    // Use the browser language if no saved language is available
    const browserLang = translate.getBrowserLang();
    const candidate = savedLang || browserLang || 'en';
    const langExists = await firstValueFrom(
      http.get(`/assets/i18n/${candidate}.json`)
    ).then(() => true).catch(() => false);
    const languageToUse = langExists ? candidate : 'en';
    localStorage.setItem('userLanguage', languageToUse);
    await firstValueFrom(translate.use(languageToUse));
  };
}